import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type WithOnboardingAnalyticsCategory } from './onboardingAnalytics';
import META from './useTrackViewedOnboardingJobTitle.meta';

export type ViewedOnboardingJobTitleParams = WithOnboardingAnalyticsCategory;

export const useTrackViewedOnboardingJobTitle = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedOnboardingJobTitle = useCallback(
    (params: ViewedOnboardingJobTitleParams) => {
      track(META.name, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackViewedOnboardingJobTitle };
};
